module.exports = __webpack_public_path__ + "img/tdb-new-logo.45942788.png";